export const asyncForEach = async (array, callback) => {
  for (let index = 0; index < array.length; index++) {
    // oxlint-disable-next-line eslint/no-await-in-loop -- callbacks must finish in input order
    await callback(array[index], index, array);
  }
};
